import React from "react";
import {ControlLabel, FormControl} from "react-bootstrap";
import util from "./../../lib/util.js";
import moment from "moment";

export default class TCSummary extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            expandTotalHours: false
        };

        this.calculateWeekTotal = this.calculateWeekTotal.bind(this);
        this.getNotes = this.getNotes.bind(this);    
        this.clearNotes = this.clearNotes.bind(this); 
        this.toggleExpandTotalHours = this.toggleExpandTotalHours.bind(this); 
    }

    calculateWeekTotal() {
        let vm = this.props.vm;        
        let hrsTotal = 0.0;
        let hrsDaily = [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0]; // [Sun, Mon... Sat]
        let hrsDailyWork = [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0]; // [Sun, Mon... Sat]
        let hrsDailyMisc = [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0]; // [Sun, Mon... Sat]

        for(let i=0; i<vm.timecardData.timecardLineDatas.length; i++) {
            let tcl = vm.timecardData.timecardLineDatas[i].timecardLine;
            let dayNo = moment(tcl.dayDate).day();

            hrsDailyWork[dayNo] += tcl.totalHour + (tcl.totalMin / 60)
            hrsDaily[dayNo] += hrsDailyWork[dayNo];
            hrsTotal += tcl.totalHour + (tcl.totalMin / 60);
        }

        for(let i=0; i<vm.misc.expenses.length; i++) {
            let expense = vm.misc.expenses[i];
            let dayNo = moment(expense.expenseDate).day();

            hrsDailyMisc[dayNo] += expense.unit;
            hrsDaily[dayNo] += expense.unit;
            hrsTotal += expense.unit;
        }

        return {hrsTotal, hrsDaily, hrsDailyWork, hrsDailyMisc};
    }

    getNotes() {        
        return this.newNotes.value;
    }

    clearNotes() {
        this.newNotes.value = "";
    }

    toggleExpandTotalHours() { 
        let currentVal = this.state.expandTotalHours;
        this.setState({ expandTotalHours: !currentVal});
    }

    render() {
        let self = this;
        let vm = this.props.vm;
        let weekTotal = this.calculateWeekTotal();
        let notes = vm.timecardData.timecard !== null ? vm.timecardData.timecard.notes : "";
        let percentage = (weekTotal.hrsTotal / vm.weeklyHour) * 100;
        let requireNewNotes = this.props.requireNotes? <span className="ap-color-red"> *</span>: "";
        let hidePercentage = this.props.hidePercentage === true;
        let showTotalHoursDaily = this.props.showTotalHoursDaily === true;
        
        if (percentage > 100) {
            percentage = 100;
        }
       
        return(
            <div className="container">
                <div className={showTotalHoursDaily ? "row hidden-sm hidden-xs" : "ap-hidden"}>
                    <div className="col-md-12">
                        <table className="ap-summary-grid">
                            <tbody>
                                <tr key="dailyTotal">   
                                    <td className="code">&nbsp;</td>
                                    <td>
                                        <span onClick={this.toggleExpandTotalHours} className={this.state.expandTotalHours ? "fa fa-minus ap-pointer" : " fa fa-plus ap-pointer"}></span>&nbsp;
                                        Daily Total Hours</td>
                                    <td className="text-right duration">&nbsp;</td>
                                    <td className="text-right duration">{weekTotal.hrsDaily[0].toFixed(2)}</td>
                                    <td className="text-right duration">{weekTotal.hrsDaily[1].toFixed(2)}</td>
                                    <td className="text-right duration">{weekTotal.hrsDaily[2].toFixed(2)}</td>
                                    <td className="text-right duration">{weekTotal.hrsDaily[3].toFixed(2)}</td>
                                    <td className="text-right duration">{weekTotal.hrsDaily[4].toFixed(2)}</td>
                                    <td className="text-right duration">{weekTotal.hrsDaily[5].toFixed(2)}</td>
                                    <td className="text-right duration">{weekTotal.hrsDaily[6].toFixed(2)}</td>
                                </tr>
                                {
                                    this.state.expandTotalHours? 
                                        [
                                            <tr key="dailyTotalWork" className="expansion">   
                                                <td className="code">&nbsp;</td>
                                                <td className="description">Working Total Hours</td>
                                                <td className="text-right duration">&nbsp;</td>
                                                <td className="text-right duration">{weekTotal.hrsDailyWork[0].toFixed(2)}</td>
                                                <td className="text-right duration">{weekTotal.hrsDailyWork[1].toFixed(2)}</td>
                                                <td className="text-right duration">{weekTotal.hrsDailyWork[2].toFixed(2)}</td>
                                                <td className="text-right duration">{weekTotal.hrsDailyWork[3].toFixed(2)}</td>
                                                <td className="text-right duration">{weekTotal.hrsDailyWork[4].toFixed(2)}</td>
                                                <td className="text-right duration">{weekTotal.hrsDailyWork[5].toFixed(2)}</td>
                                                <td className="text-right duration">{weekTotal.hrsDailyWork[6].toFixed(2)}</td>
                                            </tr>,
                                            <tr key="dailyTotalMisc" className="expansion">   
                                                <td className="code">&nbsp;</td>
                                                <td className="description">Misc Total Hours</td>
                                                <td className="text-right duration">&nbsp;</td>
                                                <td className="text-right duration">{weekTotal.hrsDailyMisc[0].toFixed(2)}</td>
                                                <td className="text-right duration">{weekTotal.hrsDailyMisc[1].toFixed(2)}</td>
                                                <td className="text-right duration">{weekTotal.hrsDailyMisc[2].toFixed(2)}</td>
                                                <td className="text-right duration">{weekTotal.hrsDailyMisc[3].toFixed(2)}</td>
                                                <td className="text-right duration">{weekTotal.hrsDailyMisc[4].toFixed(2)}</td>
                                                <td className="text-right duration">{weekTotal.hrsDailyMisc[5].toFixed(2)}</td>
                                                <td className="text-right duration">{weekTotal.hrsDailyMisc[6].toFixed(2)}</td>
                                            </tr>
                                        ] : []
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="ap-bkg-color-gray ap-color-white ap-section-header">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className={hidePercentage? "col-md-12 text-center" : "col-md-6"}>
                                        <span className="ap-h4">Week Total: </span><span>{util.toHrmString(weekTotal.hrsTotal)}</span>
                                    </div>
                                    <div className={hidePercentage? "ap-hidden" : "col-md-3"}>
                                        <div className="ap-fullsize">
                                            <div className="ap-border-color-white ap-bkg-color-white">
                                                <div className="ap-bkg-color-allin1-green" style={{width: `${percentage}%`, height:"20px"}}></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={hidePercentage? "ap-hidden" : "col-md-3"}> 
                                        Progress ({vm.weeklyHour} Scheduled hours)
                                    </div>
                                </div>
                            </div>                            
                        </div>
                    </div>                    
                    
                </div>
                <div className={vm.timecardData.timecard == null? "row ap-hidden": "row ap-top-margined"}>
                    <div className="col-md-6">
                        <ControlLabel>Read timecard notes:</ControlLabel>                        
                        <FormControl componentClass="textarea" inputRef={ref => { 
                                if (ref!=null) ref.readOnly=true;                                                              
                            }} rows="4" defaultValue={notes}></FormControl>
                    </div>
                    <div className="col-md-6">
                        <ControlLabel>Write a timecard note:{requireNewNotes}</ControlLabel>
                        <FormControl componentClass="textarea" placeholder="Note" rows="4" 
                        inputRef={ref => self.newNotes = ref}></FormControl>
                    </div>
                </div>
            </div>
            );
    }
}